/* RemixStyle.js */

import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Button, Row, Col, Card, CardBody } from 'reactstrap';
import Assets from '../../services/Assets';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import { FaTimes } from 'react-icons/fa';
import StickyBox from 'react-sticky-box';

const EXPRESS_URL = process.env.REACT_APP_EXPRESS_URL;

export default function RemixStyle({ parentSelectCallback, parentStyle, setParentStyle, showSaveButton, saveButtonCallback, processHashtagStyle, doScrollTop = false, createMode, editMode, remixStyle }) {
  const { toggleLoading } = useAuth();

  const [categoriesSet, setCategoriesSet] = useState();
  const [activeCategorySet, setActiveCategorySet] = useState(0);
  const [categories, setCategories] = useState();
  const [catsImages, setCatsImages] = useState();
  const [categoryView, setCategoryView] = useState(false);
  const [activeCategoryName, setActiveCategoryName] = useState();
  const [styles, setStyles] = useState();

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const selectStyle = useCallback((style) => {
    const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
    const backImgLoc = style.backImgLoc;
    const posterSrc = `${backgroundsImgs}${backImgLoc}`;
    const videoSrc = EXPRESS_URL.replace('{id}', style.id);
    style.posterSrc = posterSrc;
    style.videoSrc = videoSrc;
    style.categoryName = categoriesSet[activeCategorySet]['title'];
    style.styleName = activeCategoryName;

    if (setParentStyle) {
      setParentStyle(style);
    }
    if (parentSelectCallback) {
      parentSelectCallback(style);
    }
    if (doScrollTop) { scrollTop(); }
  }, [catsImages, parentSelectCallback, setParentStyle, doScrollTop, categoriesSet, activeCategorySet, activeCategoryName]);

  const unselectStyle = useCallback(() => {
    setParentStyle();
  }, [setParentStyle]);

  const renderStyle = useCallback((style, index) => {
    if (style) {
      const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
      const backImgLoc = style.backImgLoc;
      const posterSrc = `${backgroundsImgs}${backImgLoc}`;
      const videoSrc = EXPRESS_URL.replace('{id}', style.id);

      return (
        <Col md={3} key={`${style.id}_${style.BaName}_${index}`} className='mb-3 cat-style-video-container'>
          <video
            playsInline
            preload='none'
            poster={posterSrc}
            className='cat-style-video-element'
            controls
            controlsList='nodownload noplaybackrate noremoteplayback'
            disablePictureInPicture
          >
            <source src={videoSrc} type='video/mp4' />
          </video>
            <Button
              className='cat-style-video-button shadow pb-btn-1'
              onClick={() => selectStyle(style)}
              size='sm'
            >
              {Strings('use')}
            </Button>
          <div className='text-right'>
            
          </div>
        </Col>
      );
    }
  }, [catsImages, selectStyle]);

  const showStyles = useCallback(async (cat, name) => {
    setActiveCategoryName(name);
    setCategoryView(true);
    setStyles();

    toggleLoading(true);
    let style;

    try {
      style = await Assets.getStyle(cat);
    } catch (err) {
      toast.error(`${Strings('error_while_getting_style')} [ID==04]`);
    }

    if (style) {
      setStyles(style);
    }
    toggleLoading(false);
  }, [toggleLoading, setActiveCategoryName, setCategoryView, setStyles]);

  const renderCategoryCard = useCallback((cat) => {
    if (catsImages && catsImages.its && catsImages.its[cat]) {
      let targetCategory;
      if (categories && categories.its) {
        targetCategory = categories.its.filter((value) => {
          return parseInt(value.id) === cat;
        });
      }

      if (targetCategory && targetCategory[0]) {
        const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
        const src = backgroundsImgs + catsImages.its[cat].img;
        const name = catsImages.its[cat].name;

        return (
          <Col lg={3} md={3} key={cat} className='mb-3'>
            <img
              className='img-fluid rounded cursor-pointer'
              src={src}
              alt={name}
              onClick={() => {
                showStyles(cat, targetCategory[0].la);
                if (processHashtagStyle) {
                  processHashtagStyle(targetCategory[0].la);
                }
              }}
            />
            <p
              className='cat-card-name text-center m-0 cursor-pointer'
              onClick={() => {
                showStyles(cat, targetCategory[0].la);
                if (processHashtagStyle) {
                  processHashtagStyle(targetCategory[0].la);
                }
              }}
            >
              {targetCategory[0].la}
            </p>
          </Col>
        );
      }
    }
  }, [catsImages, categories, showStyles, processHashtagStyle]);

  const generateInitialStyle = useCallback(async ({ currentStyle, categories, generalCategories, catsImages }) => {
    const { estylesid } = currentStyle;
    let categoryId;
    const template = {};

    if (estylesid && generalCategories && categories) {
      generalCategories.its.forEach((item) => {
        const { ts } = item;
        if (ts) {
          const splitted = ts.split(',');
          splitted.forEach((subitem) => {
            if (parseInt(subitem) === parseInt(estylesid)) {
              template.styleName = item.la;
              categoryId = parseInt(item.id);
            }
          });
        }
      });

      if (categoryId) {
        categories.its.forEach((item) => {
          if (item.cats && item.cats.includes(categoryId)) {
            template.categoryName = item.title;
          }
        });

        try {
          const templatesForCat = await Assets.getStyle(categoryId);
          if (templatesForCat) {
            const selectedTemplate = templatesForCat.filter((item) => item && item.id && parseInt(item.id) === parseInt(estylesid));
            if (selectedTemplate && selectedTemplate[0]) {
              const style = selectedTemplate[0];
              const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'https://') + '/';
              const backImgLoc = style.backImgLoc;
              const posterSrc = `${backgroundsImgs}${backImgLoc}`;
              const videoSrc = EXPRESS_URL.replace('{id}', style.id);
              style.posterSrc = posterSrc;
              style.videoSrc = videoSrc;
              style.styleName = template.styleName;
              style.categoryName = template.categoryName;

              if (setParentStyle) { setParentStyle(style); }
            }
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
  }, [setParentStyle]);

  const getCategories = useCallback(async () => {
    toggleLoading(true);
    let categories, generalCategories, catsImages;

    try {
      categories = await Assets.getCategoriesSet();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==01]`);
    }

    try {
      generalCategories = await Assets.getCategories();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==02]`);
    }

    try {
      catsImages = await Assets.getCatImages();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_categories')} [ID==03]`);
    }

    if (catsImages) {
      setCatsImages(catsImages);
    }
    if (generalCategories) {
      setCategories(generalCategories);
    }
    if (categories && categories.its) {
      const localSet = categories.its;
      localSet[0].title = 'Classic';
      localSet[4].title = 'Modern';
      localSet[5].title = 'Business';

      const newSet = [];
      newSet.push(localSet[1]);
      newSet.push(localSet[2]);
      newSet.push(localSet[3]);
      newSet.push(localSet[0]);
      newSet.push(localSet[4]);
      newSet.push(localSet[5]);
      
      setCategoriesSet(newSet);
    }

    toggleLoading(false);

    if (remixStyle && parentStyle === undefined) {
      generateInitialStyle({ currentStyle: remixStyle, categories, generalCategories, catsImages })
    }
  }, [setCategoriesSet, setCategories, setCatsImages, toggleLoading, remixStyle, generateInitialStyle, parentStyle]);

  useEffect(() => { getCategories(); }, [getCategories]);

  return (
    <Fragment>

      {parentStyle && (
        <Card className='mb-4 shadow'>
          <CardBody>
            <Row className='align-items-center'>
              <Col md={3}>
                <img
                  width={160}
                  className='rounded'
                  alt={parentStyle.BaName}
                  src={parentStyle.posterSrc}
                />
              </Col>
              <Col md={6}>
                <div className='d-flex'>
                  {parentStyle.categoryName && (
                    <div>
                      <p className='mb-0 mr-10px'><small className='text-muted'>{Strings('category')}</small></p>
                      <p className='mb-1 h6 mr-10px'>{parentStyle.categoryName}</p>
                    </div>
                  )}
                  {parentStyle.styleName && (
                    <div>
                      <p className='mb-0'><small className='text-muted'>{Strings('style')}</small></p>
                      <p className='mb-1 h6'>{parentStyle.styleName}</p>
                    </div>
                  )}
                </div>
                <p className='mb-0'><small className='text-muted'>{Strings('template')}</small></p>
                <p className='mb-1 h4'>{parentStyle.BaName}</p>
              </Col>
              <Col md={3}>
                <div className='d-flex justify-content-end'>
                  {createMode && (
                    <Button
                      color='danger'
                      outline
                      size='sm'
                      onClick={unselectStyle}
                    >
                      {Strings('unselect')}
                    </Button>
                  )}
                  
                  {showSaveButton && saveButtonCallback && (
                    <Button
                      color='primary'
                      onClick={saveButtonCallback}
                    >
                      {Strings('update_style')}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}

      {!categoryView && (
        <Fragment>
          <StickyBox offsetTop={60}>
            <div className='d-flex justify-content-center'>
              <div className='btn-group mb-3'>
                {categoriesSet && categoriesSet.length > 0 && categoriesSet.map((value, index) => (
                  <Button
                    key={index}
                    outline
                    className='mb-2 mr-2 pb-btn-2'
                    color='primary'
                    active={activeCategorySet === index}
                    onClick={() => setActiveCategorySet(index)}
                  >
                    {value.title}
                  </Button>
                ))}
              </div>
            </div>
          </StickyBox>

          {categoriesSet && categoriesSet.length > 0 && categoriesSet.map((value, index) => (
            <Fragment key={index}>
              {activeCategorySet === index && (
                <Row>
                  {value.cats && value.cats.map((cat) => renderCategoryCard(cat))}
                </Row>
              )}
            </Fragment>
          ))}
        </Fragment>
      )}

      {categoryView && (
        <Fragment>
          <Row className='mb-4'>
            <Col>
              <span className='cursor-pointer p-3 close-button-styles align-middle' onClick={() => setCategoryView(false)}>
                <FaTimes />
              </span>
              <span className='h5 align-middle name-select-styles'>
                {activeCategoryName} {Strings('styles')}
              </span>
            </Col>
          </Row>

          <Row>
            {styles && styles.length > 0 && styles.map((value, index) => renderStyle(value, index))}
          </Row>
        </Fragment>
      )}

    </Fragment>
  );
}
